import React, { useEffect, useState } from 'react';
import { Button, Input, Space } from 'antd';
import classNames from 'classnames';
import { RefCode } from 'components/TableSearchBox';
import 'components/TableSearchBox/index.scss';
import { SearchRangePicker } from 'components/atoms'
import moment, { Moment } from 'moment';
import { RangeValue } from 'rc-picker/lib/interface';
import { dateFormat } from 'utils/date-utils';

const cx = classNames.bind('./index.scss');
export interface ProjectSearchBoxProp {
  onSearch : (data: any) => void;
  onReset : () => void;
}

const ProjectSearchBox = ({onSearch, onReset}: ProjectSearchBoxProp): React.ReactElement => {
  /* ======================================================
   * hooks
   * ====================================================== */

  /* ======================================================
   * variables
   * ====================================================== */

  /* ======================================================
   * states
   * ====================================================== */
  const [searchInput, setSearchInput] = useState<string>('');
  const [searchRange, setSearchRange] = useState<RangeValue<Moment>|null>();
  const [searchSubject, setSearchSubject] = useState<string|undefined>(undefined);
  const [searchType, setSearchType] = useState<string|undefined>(undefined);

  /* ======================================================
   * events
   * ====================================================== */
  const onChange = (e) => {
    setSearchInput(e.target.value);
  };

  const onClickReset = (e) => {
    setSearchType(undefined);
    setSearchSubject(undefined);
    setSearchInput('');
    setSearchRange(null);

    onReset();
  };

  const onChangePeriod = (date: RangeValue<Moment>, dateString: [string, string]) => {
    setSearchRange(date);

    const searchDateS = dateString[0] ? dateFormat(dateString[0], 'YYYYMMDD') : '';
    const searchDateE = dateString[1] ? dateFormat(dateString[1], 'YYYYMMDD') : '';

    onSearch({ searchDateStart: searchDateS, searchDateEnd: searchDateE, pageNo: 1 });
  };

  /* ======================================================
   * effects
   * ====================================================== */

  /* ======================================================
   * render items
   * ====================================================== */
  return (
    <div className={cx('tableSearchBoxWrapper')}>
      <Space direction='vertical'>
        <Space>
          <SearchRangePicker value={searchRange} format="YYYY-MM-DD" onChange={onChangePeriod} style={{width:'250px'}} /> 
          <RefCode codeValue={searchSubject} fieldName={'lecture_subject1'} placeholder={'강의주제'} onChangeSelect={(value)=>{onSearch({ lecture_subject: value, pageNo: 1 }); setSearchSubject(value)}} />
          <RefCode codeValue={searchType} fieldName={'lecture_type1'} placeholder={'강의구분'} onChangeSelect={(value)=>{onSearch({ lecture_type: value, pageNo: 1 }); setSearchType(value)}} />        
          <Input.Search
            className={cx('searchInput')}
            value={searchInput}
            placeholder="검색어를 입력하세요"
            onChange={onChange}
            onSearch={(value)=>onSearch({ searchValue: value, pageNo: 1 })}
            allowClear
          />
          <Button onClick={onClickReset}>
            검색초기화
          </Button>                
        </Space>      
      </Space>
    </div>
  );
};

export default ProjectSearchBox;
